if (document.querySelector(".newsroom")) {
  import("./modules/newsroom.module.js").then((module) => module.init());
}

if (document.querySelector(".ctype-ce_states_map")) {
  import("./modules/statesMap.module.js").then((module) => module.init());
}

if (document.querySelector(".slider-3")) {
  import("./modules/swiper3.module.js").then((module) => module.init());
}

if (
  document.querySelector(".box_inhalt.ext") ||
  document.querySelector(".js-player.local")
) {
  import("./modules/plyr.module.js").then((module) => module.init());
}

if (document.querySelector(".ctype-ce_video_gallery")) {
  import("./modules/videoGallery.module.js").then((module) => module.init());
}

if (
  document.querySelector("aswc-parallax") ||
  document.querySelector("aswc-scroll-blend") ||
  document.querySelector("aswc-vert-img-vid-slider")
) {
  import("./modules/scrollytelling.module.js").then((module) => module.init());
}

if (document.querySelector('[data-js="faq-list"]')) {
  import("./modules/faq.module.js").then((module) => module.init());
}

if (document.querySelector(".lottie-wrapper")) {
  import("./modules/lottie.module.js").then((module) => module.init());
}

if (document.querySelector(".gemtimecont")) {
  import("./modules/gTime.module.js").then((module) => module.init());
}

if (document.querySelector(".gem-carousel-outer-wrapper")) {
  import("./modules/gCarousel.module.js").then((module) => module.init());
}

if (document.querySelector(".news-overview")) {
  import("./modules/pagination.module.js").then((module) => module.init());
}

if (document.querySelector(".scroll-to-top")) {
  import("./modules/scrollToTop.module.js").then((module) => module.init());
}

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
// let attempts = 0;
// const whenComplete = () => {
//   if (++attempts > 30) return;
//   if (document.readyState === "complete") {
//     // --- code ---
//   } else {
//     setTimeout(() => whenComplete(), 400);
//   }
// };
// whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (++styleAttempts > 30) return;
//   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
//     document.querySelector("#sess").remove();
//   } else {
//     setTimeout(() => stylesComplete(), 300);
//   }
// };
// stylesComplete();
